import { getFirestore } from "firebase/firestore";
import app from "./FirebaseConfig";

export default getFirestore(app);